import { Modal, PresentationalTable } from 'components/core-v2'
import { formatCurrencyFull } from 'utilities/currency'

import { ScenarioVector } from '@/api'
import { CURRENCY } from '@/const'
import { displayPercentage } from '@/utilities/number'

export type SingleAssetDrawdown = {
  isinCode: string
  values: ScenarioVector[]
}
export type AssetDrawdownModalProps = {
  data: SingleAssetDrawdown
  isOpen: boolean
  onClose: () => void
}

const Body = ({ data, onClose }: Omit<AssetDrawdownModalProps, 'isOpen'>) => {
  const headerRow =
    data.values.length > 0
      ? [
          'Period',
          '',
          ...data.values[0].points
            .map(item => displayPercentage(item.coordinate?.bump, 2))
            .reverse()
        ]
      : []

  const rows =
    data.values.length > 0
      ? data.values.map(row => [
          row.coordinate.label,
          displayPercentage(row.coordinate.bump, 2),
          ...row.points.reverse().map(cell => formatCurrencyFull(cell.value, CURRENCY))
        ])
      : []

  return (
    <>
      <Modal.Header id="asset-drawdown-modal" onClose={onClose}>
        <h2>{data.isinCode} shocks</h2>
      </Modal.Header>
      <Modal.Body className="mb-4">
        <PresentationalTable headerRow={headerRow} rowOptions={[]} rows={rows} />
      </Modal.Body>
    </>
  )
}

export function AssetDrawdownModal({ data, isOpen, onClose }: AssetDrawdownModalProps) {
  return (
    <Modal.Wrapper
      aria-labelledby="asset-drawdown-modal"
      isOpen={isOpen}
      width="lg"
      onClose={onClose}
    >
      {data ? <Body data={data} onClose={onClose} /> : null}
    </Modal.Wrapper>
  )
}
